import React from "react";
import Tour from "reactour";
import "./style.scss";
import { connect, useDispatch } from "react-redux";

import {
  updateUserJourney,
  updateNewUserJourneyPages,
} from "../../redux/slice/authSlice";

const buttonStyle = {
  backgroundColor: "#556a9f",
  color: "white",
  borderRadius: "4px",
  padding: "8px 16px",
  border: "none",
  cursor: "pointer",
  width: "80px",
};

function UserTour({ steps, isOpen, page, newUserPageFlag }) {
  const dispatch = useDispatch();

  return (
    <>
      <Tour
        steps={steps}
        isOpen={isOpen}
        onRequestClose={() => {
          if (newUserPageFlag) {
            dispatch(updateNewUserJourneyPages({ [page]: false }));
          }
          dispatch(updateUserJourney(false));
        }}
        accentColor="#556a9f"
        badgeContent={(curr, tot) => `${curr} of ${tot}`}
        className="journey-container"
        disableInteraction={true}
        lastStepNextButton={<button style={buttonStyle}>Finish</button>}
        rounded={10}
        showCloseButton={true}
        closeWithMask={false}
        disableFocusLock={true}
        startAt={0}
      />
    </>
  );
}

const mapStateToProps = (state) => ({
  userJourney: state.auth.userJourney,
});

export default connect(mapStateToProps)(UserTour);
